import React from 'react';
import './Widget.css';

import ShowMoreButton from '../../fields/ShowMoreButton/ShowMoreButton';
import PieChart from '../../widgets/PieChart/PieChart';
import BarChart from '../../widgets/BarChart/BarChart';
import WordCloud from '../../widgets/WordCloud/WordCloud';
import ProjectCards from '../../widgets/ProjectCards/ProjectCards';
import ProjectShowcase from '../../widgets/ProjectShowcase/ProjectShowcase';
import TwoOption from '../../widgets/TwoOption/TwoOption';
import TimelineChart from '../../widgets/TimelineChart/TimelineChart';

import GlancePage from '../../page/GlancePage/GlancePage';

export default class Widget extends React.Component {
  renderWidget() {
    const { widget } = this.props.field;
    const { type } = widget;

    switch (type) {
      case 'pieChart':
        return <PieChart widget={widget} />;
      case 'barChart':
        return <BarChart widget={widget} />;
      case 'glancePage':
        return <GlancePage data={widget.data} />;
      case 'wordCloud':
        return <WordCloud widget={widget} />;
      case 'cardsShowCase':
        return <ProjectCards widget={widget} />;
      case 'itemShowCase':
        return <ProjectShowcase widget={widget} />;
      case 'twoOption':
        return <TwoOption widget={widget} />;
      case 'timeline':
        return <TimelineChart widget={widget} />;
      default:
        return '';
    }
  }

  render() {
    const { widget } = this.props.field;
    const { showMoreButton } = widget;
    const { style } = widget;
    const className = `widget ${
      style && style.extraTopBottomMargin ? 'extra-top-bottom-margins' : ''
    }`;

    return (
      <div className={className} id={this.props.id}>
        {this.renderWidget()}
        {showMoreButton &&
        showMoreButton.enabled &&
        widget.data.length > widget.max ? (
          <ShowMoreButton text={showMoreButton.text} widget={widget} />
        ) : null}
      </div>
    );
  }
}
